/**
 * @name carousel blockchain/project slider art
 * @function handle carousel with graphic art
 */

$(function() {
  var $carousel = $('#projects-carousel');
  var $prevBtn = $('#prev_project');
  var $nextBtn = $('#next_project');
  var sliderArt = $('#art-blockchain-projects');

  // Evitar doble inicialización (scripts.js + Vite glob import)
  if (!$carousel.length || $carousel.hasClass('slick-initialized')) return;

  // Inicializar carrusel
  $carousel.slick({
    dots: true,
    infinite: false,
    speed: 400,
    cssEase: 'ease-in-out',
    autoplay: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    variableWidth: true,
    accessibility: false,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  // Navegación con botones (slick maneja los límites con infinite: false)
  $prevBtn.on('click', function() {
    $carousel.slick('slickPrev');
  });
  $nextBtn.on('click', function() {
    $carousel.slick('slickNext');
  });

  // Feedback visual: oculta el botón en los extremos
  function updateNavVisual(currentSlide) {
    var slick = $carousel.slick('getSlick');

    $prevBtn.toggleClass('nav-hidden', currentSlide <= 0);
    $nextBtn.toggleClass('nav-hidden', currentSlide >= slick.slideCount - 1);

    sliderArt.toggleClass('faded', currentSlide > 0);
  }

  $carousel.on('afterChange', function(event, slick, currentSlide) {
    updateNavVisual(currentSlide);
  });

  updateNavVisual(0);
});


/**
 * @name Animation Slider blockchain/event slider
 * @function event slider carousel
 */

var transition = {
  section: {
    show: "slideInUp",
    hide: "slideOutUp",
    delayShow: "delay0s"
  },
  figure: {
    show: "slideInUp",
    hide: "slideOutUp",
    delayShow: "delay0s"
  },
  h1: {
    show: "fadeInUp",
    hide: "fadeOutDown",
    delayShow: "delay0s"
  },
  article: {
    show: "fadeInUp",
    hide: "fadeOutDown",
    delayShow: "delay0s"
  },
}

$(function(){
  // animate slider
  $(".anim-slider").animateSlider({
    autoplay: true,
    interval: 20000,
    pagination: false,
    animations: {
      0: transition,
      1: transition,
      2: transition,
      3: transition,
    }
  });

  // Swipe
  $(".anim-slider").swipe( {
    //Generic swipe handler for all directions
    swipe:function(event, direction, distance, duration, fingerCount, fingerData) {
      if (direction === 'left') {
        $('.anim-arrows-prev').click()
      } else {
        $('.anim-arrows-next').click()
      }
    }
  });
});